import { connect } from 'react-redux';
import AiAssistantSidePopup from '../../components/AiAssistant/AiAssistantSidePopup/aiAssistantSidePopup';

export default connect((state) => {
  const sData = state.aiAssistant;
  return {
    sData,
    showSidePopup: sData.get('showSidePopup'),
  };
})(AiAssistantSidePopup);
